import { Trans } from '@lingui/macro'
import { css, styles } from 'helpers'
import React from 'react'
import { Button, Subheading, Typography } from 'webbook-airways'

const SelectOption = ({
  selected,
  title,
  email,
  phone,
  address,
  onClick,
  isCreating
}) => (
  <div
    className={css({
      display: 'flex',
      alignItems: 'center',
      border: `1px solid ${styles.colors.backgroundGrey}`,
      padding: '5px 10px',
      margin: '0 0 5px 0'
    })}
  >
    <div className={css({ flex: 1, marginRight: 10 })}>
      <Subheading>{title}</Subheading>
      <Typography color="primary" variant="caption">
        {email}
      </Typography>
      <Typography color="primary" variant="caption">
        {phone}
      </Typography>
      <Typography color="primary" variant="caption">
        {address}
      </Typography>
    </div>
    <Button
      size="small"
      color="primary"
      variant="outlined"
      disabled={isCreating}
      onClick={onClick}
    >
      <Trans>Select</Trans>
    </Button>
  </div>
)

export default SelectOption
